import React from "react";

const Loader = () => {
  return (
    <div>
      <progress className="progress w-56"></progress>
    </div>
  );
};

export default Loader;
